var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"MainContentsArea js_min-height"},[_c('q-loader',{attrs:{"is-show":_vm.isLoading}},[_c('span',[_vm._v(" now loading... ")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }